var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "drawer" }, [
    _c("div", { staticClass: "side" }, [
      _c(
        "div",
        { staticClass: "mainDiv" },
        [
          _vm.navSeleIndex == 0
            ? _c("div", { staticClass: "topDiv flex" }, [
                _c(
                  "div",
                  { staticClass: "tops flex", attrs: { id: "imageList" } },
                  [
                    _c("div", { ref: "mySwipers", staticClass: "imgcasesT" }, [
                      _c("div", { staticClass: "gd-slides" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            staticStyle: { height: "100%", width: "100%" },
                          },
                          [_c("c360", { ref: "v3" })],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.navSeleIndex == 1 ? _c("xc-video") : _vm._e(),
          _vm.navSeleIndex == 2
            ? _c("div", { staticClass: "topDiv flex" }, [
                _c(
                  "div",
                  { staticClass: "tops flex", attrs: { id: "imageList" } },
                  [
                    _c("div", { ref: "mySwipers", staticClass: "imgcasesT" }, [
                      _c("div", { staticClass: "gd-slides" }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex",
                            staticStyle: { height: "100%", width: "100%" },
                          },
                          [_c("cssk", { ref: "sk" })],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
                _c("div", {
                  staticClass: "swiper-button-next",
                  on: {
                    click: function ($event) {
                      return _vm.sknexts()
                    },
                  },
                }),
                _c("div", {
                  staticClass: "swiper-button-prev",
                  on: {
                    click: function ($event) {
                      return _vm.skprevs()
                    },
                  },
                }),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "botDiv flex" },
            _vm._l(_vm.navList, function (it, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "botNav flex",
                  style: {
                    color: _vm.navSeleIndex == index ? "#fff" : "#e5e5e5",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selClick(index)
                    },
                  },
                },
                [
                  _vm._v(" " + _vm._s(it.name) + " "),
                  _vm.navSeleIndex == index
                    ? _c("div", { staticClass: "lines" })
                    : _vm._e(),
                  _vm.navSeleIndex == index
                    ? _c("div", { staticClass: "sjx flex" }, [
                        _c("img", {
                          staticStyle: { transform: "rotate(270deg)" },
                          attrs: { src: require("images/video/xz.png") },
                        }),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }